import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { FeeDefinition } from './fee-definition.entity';

export class CreateFeeDefinitionDto extends Omit(FeeDefinition, [...BaseEntityFieldsArray, 'buyerFee', 'supplierFee']) {}
